import {
  Radio as MuiRadio,
  FormControlLabel,
  FormControlLabelProps,
} from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

type CustomFormControlLabelProps = Omit<FormControlLabelProps, 'control'>;

export interface RadioProps extends CustomFormControlLabelProps {
  className?: string;
}

const RadioImpl = React.forwardRef<HTMLInputElement, RadioProps>(
  ({ className, ...props }, ref) => {
    return (
      <FormControlLabel
        className={className}
        ref={ref}
        control={<MuiRadio />}
        {...props}
      />
    );
  }
);

export const Radio = muiStyled(RadioImpl)(({ theme }) => {
  const { disabledOpacity } = theme.palette.action;
  return css`
    &.MuiFormControlLabel-root {
      /* Ensure radio button and label are vertically aligned */
      align-items: center;
      margin-left: 0;
      margin-right: 0;

      :hover {
        opacity: 0.8;
      }

      &.Mui-disabled {
        /* override default opacity */
        opacity: ${disabledOpacity};
      }

      svg[data-testid='RadioButtonCheckedIcon'] {
        fill: ${theme.palette.primary.main};
        scale: 1.6;
      }

      .MuiFormControlLabel-label {
        color: ${theme.palette.text.primary};
        /* Ensure label is vertically centered with radio button */
        display: flex;
        align-items: center;
      }
    }
  `;
});

export default Radio;
